import { render } from "./CustomCategoryLinkedProgramListView.vue?vue&type=template&id=1885ecf8&scoped=true&ts=true"
import script from "./CustomCategoryLinkedProgramListView.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryLinkedProgramListView.vue?vue&type=script&lang=ts"

import "./CustomCategoryLinkedProgramListView.vue?vue&type=style&index=0&id=1885ecf8&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1885ecf8"]])

export default __exports__